














































import { Getter, Action } from 'vuex-class';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import html2canvas from 'html2canvas';

import CONFIG from '@/common/config';
import fetch from '@/common/api/fetch';

import getUrlParam from '@/common/utils/getUrlParam';
import { replaceString } from '@/common/utils/dealWithString';
import getActivityType from '@/common/utils/getActivityType';

const fingerPrint = require('@/assets/img/fingerprint.png');

@Component
export default class PosterMask extends Vue {
  @Getter('groupSliderList') groupSliderList!: Array<string>;
  @Getter('posterImage') posterImage!: string;
  @Getter('posterName') posterName!: string;
  @Getter('title') getterTitle!: string;
  @Getter('qrCodeUrl') qrCodeUrl!: string;
  @Getter('urlUid') urlUid!: string;
  @Getter('gachaTypeParameter') gachaTypeParameter!: object;
  @Prop({ default: false, type: Boolean }) visible!: boolean;
  @Prop() className!: string;
  templateType: string = getActivityType();

  xcxCodeUrl: string = '';
  fingerPrint: string = fingerPrint;
  posterCanvasUrl: string = '';
  posterShow: boolean = true;
  get title(): string {
    return replaceString(this.getterTitle);
  }

  @Watch('visible')
  getPosterData() {
    if (this.visible) {
      this.createPosterImage();
    }
  }
  createPosterImage() {
    // if (getUrlParam('type') !== 'share' || getUrlParam('hot')) return;
    if (this.posterCanvasUrl) return;
    Vue.$loading.show('海报生成中..');
    const env: string = (process.env.VUE_APP_DEPLOY_ENV as string) || 'dev';
    let host: string = CONFIG.localServerB;
    if (process.env.NODE_ENV === 'production') {
      host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
    }
    let scene = this.qrCodeUrl;

    if (this.urlUid) {
      scene = `${this.qrCodeUrl}&uid=${this.urlUid}`;
    }
    if (env == 'gray') {
      scene = scene.replace('xmshow', 'xmshow/gray');
    }

    const redirectUrl = `${scene}&appId=${(CONFIG.appId as any)[env]}`;

    const _qrCodeUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${(CONFIG.appId as any)[env]}&redirect_uri=${encodeURIComponent(
      redirectUrl
    )}&response_type=code&scope=snsapi_base&state=state#wechat_redirect`;

    fetch.Sales('anon/customerShow/generateSceneTicket', { scene: _qrCodeUrl }).then((res: any) => {
      this.xcxCodeUrl = `${host}sales/anon/customerShow/getXcxCode?scene=${res.result}`;
      this.$nextTick(() => {
        const dom = document.querySelector(`.${this.className}`);
        (html2canvas as any)(dom as HTMLElement, {
          useCORS: true,
          allowTaint: false
        }).then((canvas: HTMLCanvasElement) => {
          this.posterCanvasUrl = canvas.toDataURL();
          this.posterShow = false;
          Vue.$loading.hide();
        });
      });
    });
  }

  handleClose() {
    this.$emit('onClose');
  }
}
